import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ai-knowledge-loading-spinner',

  templateUrl: './ai-loading-spinner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./ai-loading-spinner.component.scss'],
})
export class AiLoadingSpinnerComponent {}
